<script setup>
import { useUserStore } from '@/stores/user';
import { useSocketStore } from '@/stores/socket';
import { useRestStore } from '@/stores/rest'
import { useRoute } from 'vue-router'
import { ElConfigProvider } from 'element-plus'

import ru from 'element-plus/dist/locale/ru.mjs'


const userStore = useUserStore()
const socketStore = useSocketStore()
const restStore = useRestStore()
const route = useRoute()

onMounted(async () => {
  restStore.init()
  await userStore.loading()
  socketStore.initialize()
})
</script>

<template>
  <div class="app">
    <Html>

    <Head>
      <Title></Title>
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com">
      <link
        href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300&family=Inter:wght@100;300;400;500;700;900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300&family=Poppins:wght@100;200;300;400;500&display=swap"
        rel="stylesheet">

    </Head>

    <Body :style="(userStore.isInited == false && route.path.indexOf('/user/register') === -1 && ( route.path.indexOf('/user') !== -1 || route.path.indexOf('/staff') !== -1 || route.path.indexOf('/teacher') !== -1) ? 'background-image: url(\'@/assets/images/loader-bg.png\');' : '')">
      <div style="display: none;">
        <svg id="portfolio_status_1" xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 15 9" fill="none">
<path d="M4.1875 4.52118L7.41827 7.75195L14.4183 0.751953" stroke="#3BB4AD" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.45703 3.7342L10.4393 0.751953" stroke="#3BB4AD" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.5 4.52051L3.73077 7.75128L4.26923 7.21282" stroke="#3BB4AD" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
        <svg id="portfolio_status_0" xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9"
          fill="none">
          <path d="M0.5 4.52118L3.73077 7.75195L10.7308 0.751953" stroke="#2F415C" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </div>

       <NuxtLayout>
          <div><NuxtPage /></div>
        </NuxtLayout>
    </Body>

    </Html>
  </div>
</template>

<style>
@import "element-plus/dist/index.css";

:root {
  --el-font-size-base: 16px !important;
  --el-font-family: 'Open Sans', sans-serif;
}

.lk-table {
  display: flex;
  gap: 15px 0;
  flex-direction: column;
}

.el-select {
  width: 100%;
}
.standart-table__entity {
  overflow: auto;
}
.el-input,
.el-input__inner,
.el-autocomplete {
  width: 100%;
}

.lk-table__actions {
  margin: 15px 0;
}

h1,
h2,
h3,
h4 {
  margin: 0;
}

html,
body {
  height: 100%;
  margin: 0;
  --el-font-family: 'Open Sans', sans-serif;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
}

.container-child {
  max-width: 1585px;
  width: 100%;
  margin: auto;
}

.el-table td.el-table__cell div {
  word-break: break-word;
}

a {
  text-decoration: none;
}
button,
a {
  cursor: pointer;
}

.field--error .field__input {
  color: #D30127;
}

.field--error .field__input {
  color: #D30127;
  border: 1px solid #D30127;
}

.field--error .field__input::placeholder {
  color: #D30127;
}

body .field--error label {
  color: #D30127;
}

body .field--error .checkbox__box {
  border: 1px solid #D30127;
}

.el-skeleton__p.is-first {
  width: 100%;
}
.upload-demo {
  width: 100%;
}
.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
  width: 24px;
  height: 24px;

  & .path {
    stroke: white;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

}

.lk-container h2 {
  color: var(--Primary, #7E247C);
  leading-trim: both;

  text-edge: cap;
  /* Title level 2 */
  font-family: Open Sans;
  font-size: 37px;
  font-style: normal;
  font-weight: 700;
  line-height: 135%;
  /* 67.5px */
  letter-spacing: 0.375px;
  margin: 0;
}

.lk-frontend {
  display: flex;
  flex-direction: column;
  gap: 30px 0;
  padding: 120px 0;
}

.caret-wrapper {
  display: none;
  width: 24px;
  height: 25px;
  content: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M16 10.252L12 14.252L8 10.252" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
}

thead .el-table__cell .cell {
  color: var(--grey_6, #2F415C);
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  /* 21px */
  letter-spacing: 0.105px;
}

thead th {
  height: 40px;
  background: #E3E6F1 !important;
}

tbody tr:nth-child(even) {
  background: #E3E6F1;
}

tbody tr:nth-child(odd) {
  background: #F4F5F9;
}

.sort-caret {
  display: none;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
.lk-container > div:not(.lk-sidebar):not(.chats):not(.sidebar-footer) {
  margin: 15px 0;
}
.cell {
  position: relative;
}

.el-table td.el-table__cell div {
  word-break: nowrap;
}

.cell .caret-wrapper {
  position: absolute;
  top: 0;
  right: 0;
}
.lk-container {
  margin-bottom: 15px;
}

.lk-sidebar {
  
}

h1 {
    font-size: 54px !important;
    }
    h2 {
    font-size: 37px !important;
    }
    h3 {
    font-size: 28px !important;}
    p { font-size: 18px !important;}
    
    
    body .lk-sidebar {
      height: 100%;
    box-shadow: inset 0 240px 100px -150px rgba(0,0,0,0.2);
    }
    
    body .lk-sidebar {
    width: 320px;
    }
    body .lk-sidebar__item { padding: 8px 28px; }
    body .lk-sidebar__item span { font-size: 16px; }
    
    body .lk-sidebar__header {
    padding: 40px 0;
    padding-top: 64px;
    }
    
    /*Только для сайдбара футер footer { margin: 0; }*/
    
    body .lk-sidebar__item:last-child { margin-top: 32px; }
    
    body .lk-container { gap: 0; }
    body .lk-card {
    margin: 0;
    padding: 36px;
    }
    
    body .chat__sidebar-header-title { font-size: 28px; }
    body .chat__sidebar-body-item-title {
    font-size: 20px;
    }
    
    body .chats {
    grid-template-columns: 2.5fr 5fr;
    }
    * {
      line-height: 150% !important;
    }
    .el-autocomplete-suggestion li {
      line-height: 34px !important;
    }


    body .el-button--large {
      color: #FFF;

text-align: center;
font-family: Open Sans;
font-size: 16px !important;
font-style: normal;
font-weight: 400;
line-height: 16px; /* 110% */
letter-spacing: -0.4px;
padding: 8px 50px;
border-radius: 0;
height: unset;
    }
    body .el-upload button {
      color: #333;

text-align: center;
font-family: Open Sans;
font-size: 16px !important;
font-style: normal;
font-weight: 400;
line-height: 16px; /* 110% */
letter-spacing: -0.4px;
padding: 6px 30px;
border-radius: 0;
height: unset;
    }

    body .el-input {
      border: 1px solid #D3D8E0;
background: #FFF;
border-radius: 0;

/* Shadow */
box-shadow: 0px 4px 8px 0px rgba(51, 51, 51, 0.02), 0px 4px 4px 0px rgba(51, 51, 51, 0.01);
    }
body .el-input__wrapper {
border-radius: 0;
}
body .el-upload .el-button--primary {
  color: #fff;
  background: #7E247C;
  border: none;
  padding: 3px 25px;
}
    body .el-input input {
      
padding: 8px 10px;
height: unset;
border-radius: 0;
    }
body .el-form-item {
  display: flex;
  align-items: center;
}
    body .el-input input, body .el-input input::placeholder {
      color: var(--grey_4, #8B97A9);

font-family: 'Open Sans';
font-size: 17px;
font-style: normal;
font-weight: 400;
line-height: normal;
    }
    body .el-input input {
      color: #333;
    }
    body .el-form-item__label {
      color: var(--grey_6, #2F415C);
font-family: 'Open Sans';
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: normal;
    }
    .el-message-box__btns button {
      background: white !important;
      border: 1px solid #ccc !important;
      color: #333 !important;
    }
    .el-table .cell {
font-family: 'Open Sans', sans-serif;
font-size: 13px !important;
font-style: normal;
font-weight: 400;
line-height: normal;
    }
    body td .el-button--text span {
      font-size: 13px !important;
    }
    body tr th:first-child {
      height: 100%;
    }
    body .caret-wrapper {
      display: none !important;
    }
    .sidebar-footer {
      display: none;
    }
    .lk-container > div:not(.lk-sidebar):not(.chats):not(.sidebar-footer) {
      margin: 25px !important;
    }
    .lk-container > div:not(.lk-sidebar):not(.chats):not(.sidebar-footer) .field {
      margin-bottom: 8px;
    }
    @media(max-width: 1024px)
    {
      body .lk-sidebar__header {
        flex-wrap: wrap;
      }
    .lk-container > div:not(.lk-sidebar):not(.chats):not(.sidebar-footer) {
      padding: 32px !important;
    }
      .el-dialog__header h3 {
        padding: 0 25px;
      }
      .lk-container h2 {
        font-size: 24px !important;
      }
      .lk-container {
        display: flex !important;
        flex-direction: column !important;
      }

      .lk-sidebar .lk-sidebar__body {
        display: none !important;
      }

      .lk-sidebar__header-container-avatar img {
        width: 80px;
        min-width: 80px;
        height: 80px; 
      }
      .upload-demo {
        display: none;
      }

      .lk-sidebar__header {
        display: flex !important;
        flex-direction: row !important;
        gap: 0 17px !important;
        align-items: !important;
        padding: 17px 22px !important;
      }

      .lk-sidebar {
        z-index: 100;
        width: 100% !important;
        box-shadow: unset !important;
        height: unset !important;
      }
      body .sidebar-footer {
        display: flex;
        flex-direction: row;
        width: 100%;
        top: 120px;
        left: 0;
        right: 0;
        height: 62px;
        padding: 0 !important;
        overflow-x: auto;
        z-index: 100;
      }

      .sidebar-footer .lk-sidebar__body {
        display: flex;
        flex-direction: row !important;
      }

      .sidebar-footer .lk-sidebar__item {
        background: #B0BAC9;
        margin: 0 !important;
        display: flex;
        gap: 0 15px;
      }
      .sidebar-footer .lk-sidebar__item span {
        font-size: 12px;
      }
      table {
      }
      body h1 {
        font-size: 20px !important;
      }
      table tr:first-child {
        
    background: #E3E6F1 !important;
      }

      h3 {
        font-size: 16px !important;
      }

      .el-dialog {
        width: 96% !important;
      }
      body .el-form-item {
        align-items: flex-start !important;
        display: flex !important; flex-direction: column !important;
      }

      body .el-form-item__content {
        width: 100% !important;
      }

      body .el-form-item__content .upload-demo {
        display: block !important;
      }

      .lk-container {
        padding-bottom: 50px !important;
      }
      body .chats {
        display: flex !important;
        flex-direction: column !important;
      }
      body .lk-container--grid-chat {
        padding-bottom: 100px;
      }
      .chat-body-footer {
        padding: 3px !important;
      }
      .chat-body-area {
}
.el-timeline-item__timestamp {
  width: 100%;
    word-break: break-all;
}
body .lk-sidebar {
}
.lk-container > div:not(.lk-sidebar):not(.chats):not(.sidebar-footer) {
  margin-top: 25px !important;
}

.lk-table__container {
  overflow: auto;
  width: 100%;
}
.hide {
  display: none !important;
  padding: 0 10px !important;
  right: 0 !important;
}
.el-table--fit {
  width: 1000px !important;
  max-width: 1000px !important;
}

table {
  width: auto !important;
}
.el-table__body-wrapper, .el-table__footer-wrapper, .el-table__header-wrapper {
width: unset !important;
}
.user-register-confirm__area {
  gap: 0 !important;
    display: flex;
    flex-direction: column;
}
.user-register-confirm__area-column {
  gap: 15px 0;
}
.user-register-confirm__area-title{
  
  margin-top: 15px !important;
    text-align: center;
}
.user-register-confirm__area-button {
  width: 100%;
}
}
body .el-select-dropdown__item {
  line-height: 34px !important;
}
body th .cell {
  white-space: nowrap !important;
  text-overflow: unset !important;
}
body .chat__sidebar-body-item-title {
font-size: 14px !important;
}
body .el-notification__title {
  font-size: 16px !important;
}
body .el-notification__content p {
  text-align: left !important;
  font-size: 14px !important;
}
      body tbody td .cell {
        font-size: 13px !important;
      }
</style>